import React, { useMemo, useState, useEffect } from "react";

import { Select } from "antd";
// import { MdAdd } from "react-icons/md";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useContext } from "react";
import ConstituencyContext from "../../context/constituencyContext";
import ConstituencyInfo from "./ConstituencyInfo";
import { useTranslation } from "react-i18next";
import VillageData from "./VillageInfo";

import ConstituencyData from "./ConstituencyInformation";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { useQuery } from "react-query";

const Constituency = ({ constituencyData, loading }) => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();

  const [selectedMarker, setSelectedMarker] = useState({});
  const [electionYears, setElectionYears] = useState([]);
  // const [yearSelected, setYearSelected] = useState("");
  const [year, setYear] = useState();
  const [previousYear, setPreviousYear] = useState();
  const constituencyContext = useContext(ConstituencyContext);
  const handleModal = () => {
    constituencyContext.updateOpenModal(true);
  };
  let constituencyId;
  let insideConstituencyData;
  const user = JSON.parse(localStorage.getItem("user"))
  const storedConstituencyDataRaw = localStorage.getItem("constituencyData");
  const storedConstituencyData = storedConstituencyDataRaw ? JSON.parse(storedConstituencyDataRaw) : null;
  if(storedConstituencyData?.data?.type==='central')
  {
    insideConstituencyData = JSON.parse(localStorage.getItem("insideParliamentaryPolygonData"));
    constituencyId = insideConstituencyData ? insideConstituencyData.constituencyId : null;
  }
  else{
    constituencyId = constituencyData ? constituencyData._id : null;
  }
  const getIsDataAvailable = (summaryData) => {
    const checkAvailability = (key) =>
      ["YES", "Yes"].includes(summaryData[key]);

    return (
      checkAvailability("Form 20") &&
      checkAvailability("Electoral Roll") &&
      checkAvailability("PS Village Mapping Data") &&
      checkAvailability("Village Data")
    );
  };
  // API request function
  const fetchConstituencyByState = async (id, year) => {
    return axiosInstance.get(
      `api/constituency/getConstituencySummaryById/${id}?year=${year}`
    );
  };

  // Query using react-query
  const queryData = useQuery(
    ["summary-data", constituencyId, year],
    () => {
      if (constituencyId && year) {
        return fetchConstituencyByState(constituencyId, year);
      } else {
        // Return a resolved promise with null data
        return Promise.resolve(null);
      }
    },
    {
      refetchOnWindowFocus: false,
      retry: 1
    }
  );

  // Access the data from the query response
  const summaryData = queryData?.data?.data?.data || {};
  const isDataAvailable = getIsDataAvailable(summaryData);

  const fetchConstituencyTableById = async (constituencyId, year) => {
    if (constituencyId && year) {
      // Check if both constituencyId and year are defined
      return axiosInstance.get(
        `api/constituency/getConstituencyTableById/${constituencyId}?years=${year}`
      );
    } else {
      return null;
    }
  };

  const constituencyTableData = useQuery(
    ["client-constituency-table", constituencyId, year],
    () => fetchConstituencyTableById(constituencyId, year),
    {
      enabled: constituencyId !== undefined && year !== undefined,
      refetchOnWindowFocus: false,
      retry: 1
    }
  );
    
  const constituencyDataList = constituencyTableData?.data?.data?.data;
  const constituencyLoading = constituencyTableData?.isLoading || true;

  const center = useMemo(() => {
    return (constituencyTableData?.data?.data?.data?.villageData || []).map(
      (village) => {
        if (village !== null && village?.location != null) {
          const parts = village?.location.split(", ");

          // Extract latitude and longitude values
          const lat = parseFloat(parts[0].split(":")[1].trim());
          const long = parseFloat(parts[1].split(":")[1].trim());

          return {
            lat: +lat,
            lng: +long,
            title: village?.villageName,
            village_id: village?._id,
            winnerParty: village?.winnerParty,
            runnerUpParty: village?.runnerUpParty,
            firstRunnerUpParty: village?.firstRunnerUpParty
          };
        } 
        else if ((village !== null && village?.location) === null) {
          return {
            lat: 28.7041,
            lng: 77.1025, //delhi coordinate if lat lng not available
            title: village?.villageName,
            village_id: village?._id,
            winnerParty: village?.winnerParty,
            runnerUpParty: village?.runnerUpParty,
            firstRunnerUpParty: village?.firstRunnerUpParty
          };
        } 
        else {
          return null;
        }
      }
    );
  }, [constituencyTableData]);

  useEffect(() => { 
    if (constituencyId) {
      const fetchElectionYears = async () => {
        try {
          const response = await axiosInstance.get(
            `api/constituency/getElectionYears/${constituencyId}`
          );
          setElectionYears(response.data);
          setYear(response.data?.data?.electionYears[0]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchElectionYears();
    }
  }, [constituencyId]);

  useEffect(() => {
  if (electionYears?.data?.electionYears?.length > 1 && year) {
    const sortedYears = [...electionYears.data.electionYears].sort((a, b) => b - a);
    const currentIndex = sortedYears.indexOf(year);
    if (currentIndex !== -1 && currentIndex < sortedYears.length - 1) {
      setPreviousYear(sortedYears[currentIndex + 1]);
    } else {
      setPreviousYear(undefined); // No previous year
    }
  } else {
    setPreviousYear(undefined); // Not enough years to determine previous
  }
}, [year, electionYears]);

  const fetchVillageTableById = async (id, year) => {
    return axiosInstance.get(
      `api/constituency/getVillageTableById/${id}?years=${year}`
    );
  };
  const queryVillageData = useQuery(
    ["village-data", selectedMarker?.village_id, year],
    () => fetchVillageTableById(selectedMarker?.village_id, year),
    {
      refetchOnWindowFocus: false,
      enabled: selectedMarker?.village_id !== undefined && year !== undefined,
      retry: 1
    }
  );

  const fetchPrevYearConstituencyTableById = async (constituencyId, year) => {
    if (constituencyId && year) {
      // Check if both constituencyId and year are defined
      return axiosInstance.get(
        `api/constituency/getConstituencyTableById/${constituencyId}?years=${year}`
      );
    } else {
      return null;
    }
  };
  const prevConstituencyTableData = useQuery(
      ["client-constituency-table", constituencyId,previousYear],
      () => fetchPrevYearConstituencyTableById(constituencyId,previousYear),
      {
        enabled: constituencyId !== undefined && previousYear !== undefined,
        refetchOnWindowFocus: false,
        retry: 1
      }
  );

  const currVillageName = selectedMarker?.title;

  // Find matching village from previous year by name
  const prevVillage = (prevConstituencyTableData?.data?.data?.data?.villageData || []).find(
    v => v?.villageName === currVillageName
  );

  const prevVillageId = prevVillage?._id || null;

  const prevYearVillageData=useQuery(
    ["prev-village-data", prevVillageId, previousYear],
    () => fetchVillageTableById(prevVillageId, previousYear),
    {
      refetchOnWindowFocus: false,
      enabled: prevVillageId !== null && prevVillageId!==undefined && previousYear !== undefined,
      retry: 1
    }
  );
  const prevVillageFetchedElectoralData = prevYearVillageData?.data?.data?.data?.electoralData;

  const villageLoading = queryVillageData?.isLoading || true;

  const villageFetchedData = queryVillageData?.data?.data?.data;
  // const prevVillageFetchedData = prevYearVillageData?.data?.data?.data;
  const villagesList = constituencyTableData?.data?.data?.data?.villageData;

  const handleVillageSelectChange = (id) => {
    const newMarker = center.find((item) => item?.village_id === id);
    if (newMarker) {
      setSelectedMarker(newMarker);
    }
  };

  useEffect(() => {
    if (center.length > 0) {
      setSelectedMarker(center[0]);
    }
  }, [JSON.stringify(center)]);





  
  return (
    <>
      <div className='view-constituency'>
        <div className='flex items-center justify-between mt-5 gap-[0.5rem]'>
          <div className='constituency-name w-[40%]'>
            {storedConstituencyData?.data.type==='state' && <p>
              {constituencyData?.name || "NA"}{" "}
              <span className='mr-2 pl-1'> ({t("assembly")}) {constituencyData?.district || "NA"},
                <span> {constituencyData?.state || "NA"} </span>
              </span>
              <InfoCircleOutlined onClick={handleModal} />
            </p>}
            {storedConstituencyData?.data.type==='central' && <p>
              {insideConstituencyData?.name || "NA"}{" "}
              <span className='mr-2 pl-1'> ({t("assembly")}) {insideConstituencyData?.district || "NA"},
                <span> {insideConstituencyData?.state || "NA"} </span>
              </span>
              <InfoCircleOutlined onClick={handleModal} />
            </p>}
          </div>

          <div className='flex items-center gap-[0.5rem] village-year-responsive'>
            <Select
              id='villageSelect'
              placeholder={user?.urbanRural==='Urban' ? t("select") + " " + t("Wards") :t("select") + " " + t("villages")}
              value={selectedMarker?.village_id}
              onChange={handleVillageSelectChange}
              className=''
              showSearch // Enable showSearch
              optionFilterProp='children' // Specify the property to filter on
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {/* {(villagesList || [])
                .sort((a, b) => a.villageName.localeCompare(b.villageName)) // Sort the array alphabetically
                .map((village) => (
                  <Select.Option key={village?._id} value={village?._id}>
                    {village?.villageName}
                  </Select.Option>
                ))} */}

{/* temporary updated to fix baroda constituency */}
              {(villagesList || [])
                .filter(village => village.villageName) // Optional: filter out unnamed villages
                .sort((a, b) => {
                  const nameA = a.villageName || '';
                  const nameB = b.villageName || '';
                  return nameA.localeCompare(nameB);
                })
                .map((village) => (
                  <Select.Option key={village?._id} value={village?._id}>
                    {village?.villageName || 'Unnamed Village'}
                  </Select.Option>
                ))}
            </Select>

            <Select
              className=''
              placeholder={t("selectYear")}
              onChange={(value) => setYear(value)}
              value={year}
            >
              {electionYears?.data?.electionYears.map((year) => (
                <Select.Option key={year} value={year}>
                  {year}
                </Select.Option>
              ))}
            </Select>

            {/* <button className="rounded-lg" onClick={handleAddYear}> <MdAdd /> {t("addYear")} </button> */}
          </div>
        </div>
        <div className='flex mt-2 mb-3 constituency-count'>
          <p className='mr-5'>
            {user?.urbanRural==='Urban' ? t("Wards") : t("villages")}:
            <span>{constituencyDataList?.totalVillageCount} </span>
          </p>
          <p>
            {t("pollingStations")}:
            <span> {constituencyDataList?.totalPSCount}</span>
          </p>
        </div>
        <VillageData
          // constituencyData={constituencyData}
          constituencyData={storedConstituencyData.data.type==="central"?insideConstituencyData : constituencyData}
          loading={loading}
          storedConstituencyData={storedConstituencyData}
          summaryData={summaryData}
          constituencyDataList={constituencyDataList}
          center={center}
          setSelectedMarker={setSelectedMarker}
          selectedMarker={selectedMarker}
          villageFetchedData={villageFetchedData}
          // prevVillageFetchedData={prevVillageFetchedData}
          prevVillageFetchedData={prevVillageFetchedElectoralData}
          isDataAvailable={isDataAvailable}
          isLoading={villageLoading}
          electionYears={electionYears}
          setSelectedYear={setElectionYears}
          constituencyId={constituencyId}
          year={year}
          setYear={setYear}
          previousYear={previousYear}
          setPreviousYear={setPreviousYear}
        />
        <ConstituencyData
          summaryData={summaryData}
          constituencyDataList={constituencyDataList}
          isDataAvailable={isDataAvailable}
          isLoading={constituencyLoading}
          constituencyDataType={storedConstituencyData?.data?.type}
        />
      </div>
      {constituencyContext.isOpenModal && (
        <ConstituencyInfo
          isOpen={constituencyContext.isOpenModal}
          // constituencyData={constituencyData}
          constituencyData={storedConstituencyData?.data.type==='central' ? insideConstituencyData:constituencyData}
          constituencyDataList={constituencyDataList}
          user={user}
        />
      )}
    </>
  );
};

export default Constituency;
